<!-- link mode: real navigation, crawlable -->
<a *ngIf="mode === 'link' && !disabled"
   class="pill"
   [ngClass]="['v-' + variant, 's-' + size]"
   [class.is-active]="active"
   [routerLink]="href"
   [attr.aria-label]="ariaLabel"
   [attr.aria-current]="active ? 'true' : null"
   [attr.title]="describe || null">
  <span class="code">{{label}}</span>
  <span class="count" *ngIf="showCount">{{count | number}}</span>
</a>

<!-- button mode: in-page selection -->
<button *ngIf="mode === 'button'"
        type="button"
        class="pill"
        [ngClass]="['v-' + variant, 's-' + size]"
        [class.is-active]="active"
        [disabled]="disabled"
        [attr.aria-pressed]="active"
        [attr.aria-label]="ariaLabel"
        [attr.title]="describe || null"
        (click)="onSelect($event)">
  <span class="code">{{label}}</span>
  <span class="count" *ngIf="showCount">{{count | number}}</span>
</button>

<!-- static mode: identity only, no interaction -->
<span *ngIf="mode === 'static' || (mode === 'link' && disabled)"
      class="pill is-static"
      [ngClass]="['v-' + variant, 's-' + size]"
      [class.is-active]="active"
      [attr.aria-disabled]="disabled ? 'true' : null"
      [attr.title]="describe || null">
  <span class="code">{{label}}</span>
  <span class="sr-only" *ngIf="describe">{{describe}}</span>
  <span class="count" *ngIf="showCount">{{count | number}}</span>
</span>
